/** Canonical feature keys — must match backend registry. */
export const FEATURE_KEYS = {
  /** LEGACY_MATERIAL_NAV — drop key + resolve when classic nav is retired */
  SIDEBAR_NAVIGATION: 'sidebar_navigation',

  /** Restaurant trading hours: classic accordion vs v3 redesign (`/menu-services/trading-hours` vs `/v3`). */
  TRADING_HOURS: 'trading_hours'
} as const

export type FeatureKey = (typeof FEATURE_KEYS)[keyof typeof FEATURE_KEYS]

/**
 * Keys resolved once on app load ({@link FeatureExperienceProvider}).
 * **`trading_hours`** is intentionally omitted — it is resolved with `x-restaurant-id` only from
 * {@link useTradingHoursRestaurantScopedResolve} on restaurant trading-hours routes to avoid duplicate
 * `/resolve` calls and incorrect global resolution.
 */
export const DEFAULT_FEATURE_RESOLVE_KEYS: FeatureKey[] = [FEATURE_KEYS.SIDEBAR_NAVIGATION]

/** Keys fetched with restaurant scope for trading-hours layout rollout (lazy, not on every page). */
export const TRADING_HOURS_RESTAURANT_SCOPED_RESOLVE_KEYS: FeatureKey[] = [FEATURE_KEYS.TRADING_HOURS]
